<template>
    <div>
        <table style="width: 100%;background-color: white;border-collapse: collapse;">
            <tr :item="item" v-for="item in reports" style="border-bottom:1px solid #eadede">
                <td width="70%" style="padding: 5px">
                    <div>
                        {{item.reportName}}
                    </div>
                </td>
                <td width="30%">
                    <v-btn outline dark @click="showReport(item)" color="#00ab4d" flat round small>
<!--
                        <v-icon>send</v-icon>
-->
                        Gửi báo cáo
                    </v-btn>
                </td>
            </tr>
        </table>
        <div v-if="reports.length == 0"
             style="font-weight: bold;text-align: center;padding-top: 10px;">
            Không có báo cáo nào
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import MonthReportPage from "./report/monthlyReport";
    import QuarterReportPage from "./report/quarterReport";
    import StudentReportPage from "./report/studentReport";
    import LessonReportPage from "./report/lessonReport";

    export default {
        name: "report-dashboard",
        components: {LessonReportPage, StudentReportPage, QuarterReportPage, MonthReportPage},
        props: {
            classId: {
                type: String | Number,
                default: null
            }
        },

        data: () => ({
            reports: [],
        }),

        mounted() {
            this.activeTab = 0;
        },

        computed: {},

        created() {
            this.getReportList();
        },

        methods: {
            getReportList: function () {
                if (this.classId == null) {
                    return;
                }
                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                        "/report/listDashboardReport?classId=" +
                        this.classId
                    )
                    .then(
                        data => {
                            this.reports = data;
                        },
                        error => {
                        }
                    )

            },

            showReport(report) {
                this.$emit("report",report);
            }
        }
    };
</script>